import {LoggingService} from "logging/LoggingService";
import {Assert} from "common/Assert";

/*********************************************************************
 *  api for customizing api methods
 *  @return {object}
 ********************************************************************/
export function createApiForCustomizing( course ) {

    Assert.checkArgument( course );

    // revealing public api
    return {

        /***********************************************************************
         * gets the api type
         * @return {String} scorm12
         ***********************************************************************/
        TTGetApiType: () => {
            return "accelerator_course";
        },

        /***********************************************************************
         * this function can be called from a SCO to start the following SCO.
         * @return {String}
         ***********************************************************************/
        TTNavigateForward: () => {
            if (typeof (window.onTTNavigateForward) !== "undefined") {
                return window.onTTNavigateForward();
            }
            return "false";
        },

        /***********************************************************************
         * this function can be called from a SCO to show the "table of content".
         * @return {String}
         ***********************************************************************/
        TTOpenTOC: () => {
            if (typeof (window.onTTOpenTOC) !== "undefined") {
                return window.onTTOpenTOC();
            }
            return "false";
        },

        /***********************************************************************
         * prepares the scorm api for the ttkf player with a specific sco id
         * @param {String} scoId the id of the sco
         * @return {String} 'false' if a sco is already acitve, otherwise 'true'
         ***********************************************************************/
        TTPrepareScoLaunch: (scoId) => course.initializeActiveLearningSco(scoId) ? "true" : "false",

        /***********************************************************************
         * checks, if the learning sco is in use
         * @return {String} true / false
         ***********************************************************************/
        TTSCOIsInUse: () => course.hasActiveLearningSco() ? "true" : "false",

        /***********************************************************************
         * terminates the communication to the lms api and and clears the active
         * learninge sco
         * @return {String} true / false
         ***********************************************************************/
        TTTerminate: () => {
            LoggingService.log("PublisherCourse::TTTerminate");
            return course.terminate();
        },

        TTIsDelegateApi: () => "true",

        initialize: course.initialize,
        TTGetCourseMasteryScore: course.getMasteryScore,
        TTGetCompletionThreshold: course.getCompletionThreshold,
        TTCommit: course.commit,
        TTSetScoreList: course.setScoreList,
        TTGetValue: course.getValueFromCourseOrLearningSco,
        TTGetCourseValue: modelId => course.getValue(modelId) || "false",

        /*********************************************************************
         * @deprecated does nothing useful
         ********************************************************************/
        TTSetScoInfo: () => "true"
    };
}
